import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const UsageScenariosB = () => {
    const { t } = useLang('Delta3MaxSeriesStation.UsageScenariosB');
    return (
        <section id="UsageScenariosB" className={`${styles.UsageScenariosB} GtmModuleData-section`} data-section-id={'UsageScenariosB'}>
            <EcoImg
                isOpenLazy
                pc="https://websiteoss.ecoflow.com/upload/image/1762224178548/NA%20WAVE%26GLACIER%20Teaser%20Page.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1757373952442/used-bg-2-m.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1757373952442/used-bg-2-m.jpg"
            />
            <div className="sub-text">
                <p className="title">{t('title')}</p>
                <p className="sub-title">{t('subTitle')}</p>
            </div>
        </section>
    );
};

export default UsageScenariosB;
